export const QUIZMAKERSINGLE_PROMPT_NAME = 'quizMakerSingle';
export const QUIZMAKER_COLLEGE_PROMPT_NAME = 'shortQuizCollege';
export const QUIZMAKER_AMERICAN_PROMPT_NAME = 'americanShortQuiz';
